<template>
    <div :class="setUpFxaccount?'active':' '" class="multiGrid-page h-100">
        <div class="d-flex w-100 multiviewTop">
            <div class="first-wishlist toggleHeight">
                <app-watchlist :loadChart="chart_Data[ChartIndex].loadChart" v-model="chartKeys"></app-watchlist>
            </div>
            <div class="act_web_dash calculateWidth multiGrid">
                <div class="splitTop fourGrid d-flex flex-wrap h-100"v-if="!showChart">
					<trading-view v-for="item in chart_Data" :chart_index="item.id" :key="item.id" :loadChart="item.loadChart" :mn="item.mn"></trading-view>
                </div>
                <div class="splitTop fourGrid d-flex flex-wrap h-100" v-else>
                    <chart-iq :chart_index="chart_Data[0].id" :key="chart_Data[0].id" :loadChart="chart_Data[0].loadChart" :mn="chart_Data[0].mn"></chart-iq>
                </div>
            </div>
        </div>
        <order-history></order-history>
    </div>
</template>

<script>
// import chart_section from './elements/chart-section'
import chart_iq from "../shared/chart-iq";
import trading_view from "../shared/trading-view";
import app_watchlist from '../shared/app-watchlist'
import order_history from '../shared/order/order-history'
import { commonAllmixins } from '@/plugins/commonAll'
const product_type = process.env.product_type;
export default {
    name: 'multi-view',
	mixins: [commonAllmixins],
    data() {
        return {
			currencyType: 'ALL',
			chartType: 'USD-BTC',
			order: 'open',
			rightTabs: 'watchlist',
			accordian: '1',
			indexNo: '',
			buyType: 'Market',
			buySellType: 'buy',
			technicals: 'daily',
			page : '1',
			buySell: '',
			setUpFxaccount:false,
			tradeBuySell: false,
			chart_Data: [
				{'loadChart':'EURUSD'+product_type, 'mn': 'EURUSD'+product_type,'id':0},
				{'loadChart':'EURJPY'+product_type, 'mn': 'EURJPY'+product_type,'id':1},
				{'loadChart':'GBPUSD'+product_type, 'mn': 'GBPUSD'+product_type,'id':2},
				{'loadChart':'USDJPY'+product_type, 'mn': 'USDJPY'+product_type,'id':3}
			],
            chartKeys: { 'key':"", 'mn':""},
			filterCrypto:'',
            filterType : 'ALL',
            ChartIndex : 0,
        }
    },
    watch:{
    	chartKeys(value){
    		this.chart_Data[this.ChartIndex].mn = value.mn
    		this.chart_Data[this.ChartIndex].loadChart = value.key
    	}
    },
    components:{
    	// chartSection : chart_section,
		chartIq: chart_iq,
		tradingView: trading_view,
    	appWatchlist:app_watchlist,
    	orderHistory:order_history,
    },
    methods:{
    	changeChartCurrency: function(currency){
    		this.chart_Data[this.ChartIndex].loadChart = currency           
        },
    	AddRemIndex(value){
    		if(this.indexNo == value){
    			this.indexNo = ''
    		}else{
    			this.indexNo = value
    		}
    	}
    },
	mounted() {
		const _that = this
		setTimeout(()=>{
			if(_that.showChart){
				_that.$router.push('/')
			}
		},1000)
        $(document).on("click", function(event){
			if(!$(event.target).closest('.openBuySell').length){
                _that.buySell = ''
                _that.tradeBuySell = false
            }
        });
	}
	
}
</script>


// WEBPACK FOOTER //
// src/components/website/multi-view/multi-view.vue